import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  propList: [],
  textureList: [],
  expiredTextureList: [],
  materialList: [],
  hdriList: [],
}

const curatorMissingDataSlicer = createSlice({
  name: "curatorMissingData",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setMissingPropList: (state, { payload }) => {
      state.loading = true;
      state.propList = payload;
    },
    setMissingTextureList: (state, { payload }) => {
      state.loading = true;
      state.textureList = payload;
    },
    setExpiredTextureList: (state, { payload }) => {
      state.loading = true;
      state.expiredTextureList = payload;
    },
    setMissingMaterialList: (state, { payload }) => {
      state.loading = true;
      state.materialList = payload;
    },
    setMissingHdriList: (state, { payload }) => {
      state.loading = true;
      state.hdriList = payload;
    },
  },
});

export const {
  setMissingPropList,
  setMissingTextureList,
  setExpiredTextureList,
  setMissingMaterialList,
  setMissingHdriList,
} = curatorMissingDataSlicer.actions;
export const curatorMissingDataActions = curatorMissingDataSlicer.actions;

export const curatorMissingDataSelector = (state) => state.curatorMissingData;
export const curatorMissingDataReducer = curatorMissingDataSlicer.reducer;
export default curatorMissingDataReducer;

export const selectMissingPropList = (state) => state.curatorMissingData.propList;
export const selectMissingTextureList = (state) => state.curatorMissingData.textureList;
export const selectMissingMaterialList = (state) => state.curatorMissingData.materialList;
export const selectMissingHdriList = (state) => state.curatorMissingData.hdriList;
export const selectExpiredTextureList = (state) => state.curatorMissingData.expiredTextureList